import React, { useEffect, useState } from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { ActivityLog } from '../../../../../models/ActivityLog/ActivityLog';
import { ActivityLogEvent, ActivityLogType } from '../../../../../models/ActivityLog/contracts';
import { format } from 'date-fns';

const eventDisplayMap: Record<
  ActivityLogEvent,
  { name: string; color: string }
> = {
  created: { name: 'Kreirano', color: 'green' },
  updated: { name: 'Izmenjeno', color: 'blue' },
  deleted: { name: 'Obrisano', color: 'red' }
};

const logNameDisplayMap: Record<ActivityLogType, string> = {
  product: 'Proizvod',
  category: 'Kategorija',
  order: 'Narudžbina',
  order_document: 'Dokument',
  project: 'Projekat',
  user: 'Korisnik'
};

interface ActivityLogRow {
  key: number;
  time: string;
  user: string;
  action: ActivityLogEvent;
  subject: string;
}

const columns: ColumnsType<ActivityLogRow> = [
  {
    title: 'Vreme',
    dataIndex: 'time',
    key: 'time',
    width: 80
  },
  {
    title: 'Korisnik',
    dataIndex: 'user',
    key: 'user',
    width: 120
  },
  {
    title: 'Akcija',
    dataIndex: 'action',
    key: 'action',
    width: 90,
    render: (event: ActivityLogEvent) => {
      const info = eventDisplayMap[event] || { name: event, color: 'default' };
      return <Tag color={info.color}>{info.name}</Tag>;
    }
  },
  {
    title: 'Subjekat',
    dataIndex: 'subject',
    key: 'subject',
    ellipsis: true
  }
];

const ActivityLogTable: React.FC = () => {
  const [data, setData] = useState<ActivityLogRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    ActivityLog.get({ skip: 0, take: 8 })
      .then((logs: ActivityLog[]) => {
        setData(
          logs.map((log: ActivityLog) => ({
            key: log.id,
            time: format(log.createdAt, 'HH:mm'),
            user: log.causer?.name ?? 'Sistem',
            action: log.event,
            subject: `${logNameDisplayMap[log.logName] || log.logName} (ID: ${log.subjectId})`
          }))
        );
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h3 style={{ color: '#e9e9e9', marginBottom: 16 }}>Istorija aktivnosti</h3>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="key"
        loading={loading}
        className="cs-table-wrapper"
        pagination={false}
        size="small"
      />
    </div>
  );
};

export default ActivityLogTable; 